/* eslint-disable react/jsx-boolean-value */
import ReactECharts from 'echarts-for-react';
import { useEffect, useState } from 'react';
import moment from 'moment';

import useWindowSize from '../../../../hooks/useWindowSize';
import { getDeviceTypeAnalytics } from '../../../../services/Service';

// const colors = ['#468b47','#90ee90', '#edf9eb',"#385239"];
// const colors = ['#468b47', '#66b267', '#90ee90', '#aad4ab', '#cce5cc', '#edf9eb'];

const DeviceTypeBigPieChartCard = () => {
  const { width } = useWindowSize();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [mode, setMode] = useState('ThisMonth'); // ThisYear, LastYear, ThisMonth, LastMonth

  const fetchData = async (filter) => {
    try {
      setLoading(true);
      const res = await getDeviceTypeAnalytics(filter);
      setData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let startDate = '';
    let endDate = '';

    switch (mode) {
      case 'ThisMonth':
        startDate = moment().startOf('month').toISOString();
        endDate = moment().endOf('month').toISOString();
        break;
      case 'LastMonth':
        startDate = moment().subtract(1, 'month').startOf('month').toISOString();
        endDate = moment().subtract(1, 'month').endOf('month').toISOString();
        break;
      case 'ThisYear':
        startDate = moment().startOf('year').toISOString();
        endDate = moment().endOf('year').toISOString();
        break;
      case 'LastYear':
        startDate = moment().subtract(1, 'year').startOf('year').toISOString();
        endDate = moment().subtract(1, 'year').endOf('year').toISOString();
        break;

      default:
        break;
    }

    fetchData({ endDate, startDate });
  }, [mode]);

  const chartOption = {
    title: {
      text: 'Device Type',
      left: 'left', // Align title to the left
      textStyle: {
        color: '#468b47', // Green color for the title
        lineHeight: 16, // Reduced line height
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)', // Tooltip shows name, value, and percentage
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      left: 'right', // Position legend to the right
      top: 'center', // Vertically center the legend
      formatter: (name) => {
        const data = chartOption.series[0].data;
        const total = data.reduce((sum, item) => sum + item.value, 0);
        const item = data.find((d) => d.name === name);
        const percentage = ((item.value / total) * 100).toFixed(2); // Calculate percentage

        return `${name} (${percentage}%)`; // Display name with percentage
      },
    },
    series: [
      {
        name: 'Device Type',
        type: 'pie',
        radius: width > 1400 ? '75%' : '50%',
        center: ['40%', '50%'], // Move the pie chart to the left
        data: data?.map((e) => ({
          value: e.count,
          name: e.deviceType,
        })),
        itemStyle: {
          color: (params) => {
            const colors = ['#468b47', '#90ee90', '#edf9eb', '#385239'];
            return colors[params.dataIndex % colors.length]; // Apply custom colors
          },
        },
      },
    ],
  };

  return (
    <div
      style={{
        padding: '12px',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <select
        value={mode}
        style={{ position: 'absolute', right: '12px', top: '12px', zIndex: 1 }}
        onChange={(e) => setMode(e.target.value)}
      >
        <option value="ThisYear">This Year</option>
        <option value="LastYear">Last Year</option>
        <option value="ThisMonth">This Month</option>
        <option value="LastMonth">Last Month</option>
      </select>
      <ReactECharts
        notMerge={true}
        lazyUpdate={true}
        option={chartOption}
        showLoading={loading}
        style={{ height: '400px', minHeight: '300px' }}
      />
    </div>
  );
};
export default DeviceTypeBigPieChartCard;
